module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a69f2fdf8d88246cf4c876df42f4efab.png";